import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { OrdersExportPort } from '@service/preclinical/orders-export.port';
import { IngestedOrdersExportService } from '@infra-services/ingested-orders/services/ingested-orders-export.service';
import { IngestedOrdersQueryParams } from '@model/ingested-order/ingested-order.model';

@Injectable({
  providedIn: 'root'
})
export class OrdersExportAdapter implements OrdersExportPort {
  private readonly exportService = inject(IngestedOrdersExportService);

  exportOrders(params?: IngestedOrdersQueryParams): Observable<Blob> {
    return this.exportService.exportOrders(params);
  }
}
